/// <amd-module name="Analytics/Boards/CumulativeFlowDiagramQueries/BoardsQuery" />
import { AnalyticsCacheableQueryBase } from "Analytics/Common/AnalyticsCacheableQueryBase";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";

/** Describes a WIT board */
export interface Board {
    /** The ID of the board.
     *
     *  If the ID is undefined, that means the board has not been materialized yet (i.e. a user hasn't visited it).
     *  The AX service includes these board entries with null IDs because without them, experiences that show
     *  users board options would be missing those board entries, confusing users. */
    BoardId: string | undefined;
    /** The name of the board */
    BoardName: string;
    /** The level of the board (highest board level refers to the lowest-level backlog) */
    BoardLevel: number;
    /** The backlog level name the column is associated with. */
    BoardCategoryReferenceName: string;
    /** The visibility of the board */
    IsBoardVisible: boolean;
}

/**
 * Retrieves the boards for a given team sorted by board level.
 * @param project ID or name of a project.
 * @param teamId ID of a team within the given project.
 */
export class BoardsQuery extends AnalyticsCacheableQueryBase<Board[]> {
    private static generateQueryOptions(project: string, teamId: string): ODataQueryOptions {
        return {
            entityType: "BoardLocations",
            oDataVersion: latestODataVersion,
            project,
            $apply: `filter(TeamSK eq ${teamId} and IsCurrent eq true)/groupby((BoardName,BoardId,BoardLevel,IsBoardVisible,BoardCategoryReferenceName))`,
            $orderby: "BoardLevel desc"
        };
    }

    constructor(command: string, project: string, teamId: string) {
        super(command, BoardsQuery.generateQueryOptions(project, teamId));
    }

    public getQueryName(): string {
        return "BoardsQuery";
    }
}
